exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2-HJOOdeb1cWn7gK9MDJUv{margin:0}._29buBOZove1jP4MRwLe1r9{margin:0;padding-top:.5em}.GFKOkxCnJ2XkPyv5bHBCJ{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2opEQdvvyd9vnoPnZFApfK{padding-bottom:0;padding-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"ReportCard_container": "o9eDZJ9Qqs9YSwxOh1RnY",
	"ReportCard_grid": "_2-HJOOdeb1cWn7gK9MDJUv",
	"ReportCard_item": "_29buBOZove1jP4MRwLe1r9",
	"ReportCard_heading": "GFKOkxCnJ2XkPyv5bHBCJ",
	"ReportCard_content": "_2opEQdvvyd9vnoPnZFApfK"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/ReportCard/style.postcss
// module id = 1769
// module chunks = 0